<template>
  <custom-modal
    :open="open"
    header-title="选择学习范围"
    :header-subtitle="courseTitle ? `「${courseTitle}」` : '请选择要练习的章节类型'"
    width="480px"
    :mask="true"
    :mask-closable="false"
    :show-header-close="true"
    :show-reset-button="true"
    reset-button-text="取消"
    :show-confirm-button="true"
    confirm-button-text="进入课程"
    :centered="true"
    @reset="handleCancel"
    @confirm="handleConfirm"
    @cancel="handleCancel"
  >
    <div class="flex flex-col gap-3">
      <button
        v-for="item in options"
        :key="item.label"
        type="button"
        class="min-w-0 w-full text-left p-4 flex flex-col justify-between rounded-xl transition-all border border-solid cursor-pointer bg-white dark:bg-gray-800 hover:shadow-[0_4px_16px_rgba(0,0,0,0.1)] dark:hover:shadow-[0_4px_16px_rgba(0,0,0,0.4)] hover:-translate-y-0.5"
        :class="selected === item.value
          ? 'border-primary/10 hover:!border-purple-500 bg-gradient-to-r from-purple-100/60 to-purple-50/30 dark:from-purple-900/30 dark:to-purple-800/15'
          : 'border-primary/10 hover:!border-purple-500'"
        @click="selected = item.value"
      >
        <div class="flex items-center justify-between gap-3">
          <div class="min-w-0">
            <div
              class="text-base font-semibold"
              :class="selected === item.value ? 'text-purple-600 dark:text-purple-400' : 'text-gray-900 dark:text-gray-100'"
            >
              {{ item.label }}
            </div>
            <div class="text-sm text-gray-500 dark:text-gray-400 mt-0.5">{{ item.desc }}</div>
          </div>
          <div
            class="w-5 h-5 rounded-full border-2 flex-shrink-0 flex items-center justify-center"
            :class="selected === item.value ? 'border-purple-500' : 'border-gray-300 dark:border-gray-600'"
          >
            <div
              v-if="selected === item.value"
              class="w-2.5 h-2.5 rounded-full bg-purple-500"
            />
          </div>
        </div>
      </button>
    </div>
  </custom-modal>
</template>

<script>
import CustomModal from '@/components/Modal/index.vue'
import { getChapterTypeOptionsForTypeList } from '@/utils/courseDetailNav'

export default {
  name: 'CourseTypeSelectModal',
  components: { CustomModal },
  props: {
    open: { type: Boolean, default: false },
    courseTitle: { type: String, default: '' },
    defaultType: { type: [Number, String], default: null },
    typeList: { type: Array, default: () => [] }
  },
  emits: ['confirm', 'cancel'],
  data () {
    return {
      selected: null
    }
  },
  computed: {
    options () {
      return getChapterTypeOptionsForTypeList(this.typeList)
    }
  },
  watch: {
    open (val) {
      if (val) {
        const def = this.defaultType === 1 || this.defaultType === 2 ? this.defaultType : null
        const allowed = this.options.some((o) => o.value === def)
        this.selected = allowed ? def : (this.options[0]?.value ?? null)
      }
    }
  },
  methods: {
    handleConfirm () {
      this.$emit('confirm', this.selected)
    },
    handleCancel () {
      this.$emit('cancel')
    }
  }
}
</script>
